module.exports = __webpack_public_path__ + "static/media/02_09_02.0435b422.png";